import { getDefaultHeader } from '../../services/serviceAPIHelper';
import moment from 'moment';
import { getUserLanguage } from '../../components/Login/loginService';

//const auth_server = 'http://dev.auth.olympiaviajes.es';
//const auth_server = 'http://localhost:8080';

export const listReservations = async function (filters) {
    //let url = "http://private-anon-2b502330eb-webb2bbackend.apiary-mock.com/reservation/list";
    let url = process.env.REACT_APP_API_URL_V2 + 'reservation/list';

    filters = {
        'fromDate': filters.fromDate ? filters.fromDate.format('DD/MM/YYYY') : '',
        'toDate': filters.toDate ? filters.toDate.format('DD/MM/YYYY') : '',
        'clientLocator': filters.clientLocator,
        'clientName': filters.clientName,
        'reservationState': '',
        'options': {
            'searchType': filters.dateType ? filters.dateType : '',
            'reservationState': filters.reservationState === 'all' ? '' : filters.reservationState,
            'showRoomDetail': true,
            'showCancelationFee': true,
            'sort': filters.dateType ? filters.dateType : '',
            'notify': true,
            'showTime': true,
            'showConcept': true,
            'showCatalog': true,
            'showCostPrice': true,
            'showPVPPrice': true
        }
    };

    let bodycontent = JSON.stringify(filters);
    let response = await fetch(url, {
        method: 'POST',
        body: bodycontent,
        headers: getDefaultHeader(true)
    });
    if (!response.ok) {
        let body = await response.json();
        //throw new Error(body.message);
        return Promise.reject(body);
    }
    return response.json();
};
/**
 * 
 * @param {string} id any string or localizador  ID
 */
export const listReservationById = async function (id) {
    let url = process.env.REACT_APP_API_URL_V2 + 'reservation/list/' + id;
    //http://{{api-endpoint}}:{{api-port}}/v1/transfers/availability/{{requestToken}}
    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        return result;
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const getReservationById = async function (id) {
    //let url = "https://private-anon-2b502330eb-webb2bbackend.apiary-mock.com/reservation/list";
    //reservation/U18X000055X01
    let url = process.env.REACT_APP_API_URL + 'reservation/' + id;
    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        return result;
    }
    else {
        const error = await response.json();
        throw error;
    }
};
/**
 * Servicio para cancelar la reserva.
 * @param {id de identificacion de la reserva} id
 */
export const cancelReservationById = async function (reservation) {
    //let url = "https://private-anon-2b502330eb-webb2bbackend.apiary-mock.com/reservation/list";
    //reservation/U18X000055X01
    //NOTE: cancelation date tambien lo pisa y genera el backend.
    let body = {
        'reserveId': reservation.olympiaLocator,
        'olympiaLocator': reservation.olympiaLocator,
        'execute': true,
        'cancelationDate': moment(new Date()).format('DD/MM/YYYY')
    };
    let url;
    if (reservation.type === 'Hotel') {
        url = process.env.REACT_APP_API_URL + 'reservation/' + reservation.olympiaLocator;
    } else {
        url = process.env.REACT_APP_API_URL + 'transfers/reservation/' + reservation.olympiaLocator;
    }

    let response = await fetch(url, {
        method: 'DELETE',
        body: JSON.stringify(body),
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const getAvailabilityReservation = async function (opts) {
    let query = {
        'checkInDate': opts.checkInDate,
        'nights': opts.nights,
        'rooms': opts.rooms,
    };
    query.reservation = opts.reservation;

    let bodycontent = JSON.stringify(query);
    let url = `${process.env.REACT_APP_API_URL}availability/reservation/${opts.requestCode}`;

    let response = await fetch(url, {
        method: 'POST',
        body: bodycontent,
        headers: getDefaultHeader(true)
    });

    if (!response.ok) {
        let body = await response.json();
        //throw new Error(body.message);
        return Promise.reject(body);
    }

    const availData = await response.json();


    if (!availData || (availData && availData.hotels.length === 0)) {
        availData.emptyMessage = 'La búsqueda realizada no tiene disponibilidad para las fechas y ocupación seleccionadas.';
        availData.message = ''; // emptyMessage overrides this
    }
    return availData;
};


export const errorPayment = async function (paymentHash, reserva) {
    const url = process.env.REACT_APP_API_URL + 'reservation/payment/error';

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            paymentHash,
            reserva,
        }),
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const errorMultiplePayments = async function (paymentHash, reserva) {
    const url = process.env.REACT_APP_API_URL + 'reservation/payment/error-multiple';

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            paymentHash
        }),
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const updateMultiplePayments = async function (paymentHash) {
    const url = process.env.REACT_APP_API_URL + 'reservation/payment/nuevoPago';

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            paymentHash
        }),
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};


export const doReservation = async function (reservation, isConfirmPayment, confirmPaymentHash) {
    let url = process.env.REACT_APP_API_URL + 'reservation/';
    //TODO: mover estas opciones a BACK END y solo enviar las son overrideables.
    reservation.options = {
        'showCancelationConditions': true,
        'showPVP': true,
        'allowRQ': true,
        'showSeniorOffers55': true,
        'showRestrictions': true,
        'showPrePay': true,
        'showEspecialConditions': true
    };

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            reservation,
            isConfirmPayment,
            confirmPaymentHash
        }),
        // body: JSON.stringify(reservation),
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const getPaymentToken = async function (reservations, paymentOptions, secure3d) {
    const url = process.env.REACT_APP_API_URL + 'reservation/payment/getToken';
    //8a5f3d4a8d58fa7b90999070861f6b6c0673008d6dd0963f5543fa4cedb6658d
    //66ae25d0589b5f547a10d9d26cca2213
    const payload = {
        secure3d,
        reservations,
        paymentOptions: {
            locale: getUserLanguage(),
            ...paymentOptions,
            params: {
                styleBackBoton: '0153A5',
                styleColorBoton: 'FFFFFF',
                styleBackFrame: 'FFFFFF',
                styleColorLabel: '999999',
                redirect: true,
                PaymentType: 'PN',
                RequireCardholder: true,
                target: '_top',
                PaymentChannels: 'CARD',
                p1cText: '', // p1cText: 'Acepto que mi tarjeta sea almacenada para futuros pagos',
                p1cLink: '', // p1cLink: 'https://www.olympiaviajes.es.com/privacidad/',            
                ...paymentOptions.params,
            }
        }
    };

    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const updateReservation = async function (reservationId, reservation) {
    let url = `${process.env.REACT_APP_API_URL}reservation/${reservationId}`;

    let response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(reservation),
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return response.json();
    } else {
        let pro = new Promise(function (resolve, reject) {
            try {
                response.json().then(error => {
                    return reject(error);
                });
            } catch (error) {
                return reject(error);
            }
        });
        return pro;
    }

};

export const getReservationObservations = async function (reservationId) {
    if (reservationId === undefined || reservationId === '') {
        return null;
    }
    let url = `${process.env.REACT_APP_API_URL}reservation/${reservationId}/observations`;

    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const updateReservationObservations = async function (reservationId, obs) {
    let url = `${process.env.REACT_APP_API_URL}reservation/${reservationId}/observations`;

    let response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(obs),
        headers: getDefaultHeader(true)
    });

    return await response.json();
};

export const sendMail = async function (mailData) {
    let url = `${process.env.REACT_APP_API_URL}email`;

    let response = await fetch(url, {
        method: 'POST',
        headers: getDefaultHeader(true),
        body: JSON.stringify(mailData)
    });

    return await response.json();
};



export const addFlight = function (reservationId, flight) {
    let url = `${process.env.REACT_APP_API_URL}reservation/${reservationId}/flight`;

    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(flight),
        headers: getDefaultHeader(true)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};


/**
 * Get a BLOB of the PDF (bono or proforma)
 * @param {string} olympiaLocator 
 * @param {string} type 
 */
export const getPDFForReservation = async function (olympiaLocator, type) {
    //type bono or proforma
    let url = process.env.REACT_APP_API_URL_V2 + 'reservation/list/' + olympiaLocator + '/' + type;
    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (!response.ok) {
        let body = await response.json();
        return Promise.reject(body);
    }
    return response.blob();
};
/**
 * 
 * @param {component} ui 
 * @param {String} olympiaLocator 
 * @param {bono, proforma} action 
 */
export const downloadPDFForReservation = function (ui, olympiaLocator, action) {
    ui.setState({ loading: true });
    return getPDFForReservation(olympiaLocator, action) // API call
        .then((response) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${olympiaLocator}_${action}.pdf`;
            link.click();
            ui.setState({ loading: false });
        })
        .catch(err => {
            alert(err);
            ui.setState({ loading: false });
        }
        );
};

export const openPDFForReservation = function (ui, olympiaLocator, action) {
    ui.setState({ loading: true });
    return getPDFForReservation(olympiaLocator, action) // API call
        .then((response) => {
            const isEdge = window.navigator && window.navigator.msSaveOrOpenBlob;
            //const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
            //const isSafari = navigator.userAgent.indexOf('Safari') > -1;
            const blob = new Blob([response], { type: 'application/pdf' });
            if (isEdge) {
                window.navigator.msSaveOrOpenBlob(blob, `${olympiaLocator}_${action}.pdf`);
            } else {
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            }
            ui.setState({ loading: false });
        })
        .catch(err => {
            alert(err.message);
            ui.setState({ loading: false });
        }
        );
};
export const cancelPaymentForReservation = async function (merchantOperation) {
    //let url = "reservation/payment/cancel/1234566";
    //reservation/U18X000055X01
    let url = process.env.REACT_APP_API_URL + 'reservation/payment/cancel/' + merchantOperation;
    let response = await fetch(url, {
        method: 'POST',
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        return result;
    }
    else {
        const error = await response.json();
        throw error;
    }
};


// WEBPACK FOOTER //
// ./src/components/Reservations/reservationsServices.js